import { render, staticRenderFns } from "./PortalVisitorsStatistics.vue?vue&type=template&id=2b9701b3&"
import script from "./PortalVisitorsStatistics.vue?vue&type=script&lang=ts&"
export * from "./PortalVisitorsStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports